 import React, { Component, Fragment } from 'react';
 import DatePicker from 'react-datepicker';
 import moment from 'moment'
 import Form from 'react-validation/build/form';
 import TmReactTable from '../../../components/utilComponents/tmReactTable/tmReactTable';
 import { getDriverInspectionReport, getDriverInspectionReportPdf, updateIsDefectsCorrected } from '../../../actions/reportAction/fleetManagementAction/driverInspection';
 import { notify } from '../../../util/notifications';
 import ReactSelect from '../../../components/utilComponents/tmSlimSelect/reactSelect';
 import { fetchAllTruckList, fetchAllDriverList } from '../../../actions/reportAction/allinvoice/allinvoice';
 import { withRouter } from 'react-router-dom';
 import { connect } from 'react-redux';
 import { Modal } from 'react-bootstrap';
 import { getBasicAccess } from '../../../util/customMethods';
 import TmExportExcel from '../../../components/utilComponents/tmExportExcel/tmExportExcel';

 const pageTitle = 'Driver Vehicle Inspection Report'
 const basicAccess = getBasicAccess('Fleet Management');
 class DrvirInspection extends Component {
    constructor(props) {
		super(props);
		this.state = {
            inspectionData:'',
            isDefected:true,
            fromDate: '',
            empId: '',
            driverID: '',
            truckId: '',
            editNoteModalIsOpen: false,
            idTruck_PreInspection_Record: 0,
            driverIdtobeFix: 0,
            notes: ""
        }
    }

    componentWillMount = () => {   
         const {dispatch} = this.props;
          dispatch(fetchAllTruckList());  
          dispatch(fetchAllDriverList());
         }
    onSummaryByFieldChange = (key, value) => {
            this.setState({[key]:value});
    }
    getInspectionReport = (empId, date, truckId, isDefected) => {
        this.props.dispatch(getDriverInspectionReport(empId, date, truckId, isDefected));
    }
    getInspectionReportPdf = (id) => {
         this.props.dispatch(getDriverInspectionReportPdf(id));
    }

    handleDateChange = (date, key) => {
        const formattedDate = date ? moment(date).format('YYYY-MM-DD') : null;
            // "date" here is a JavaScript Date object or null
            if (date) {
              // Store a moment object in state if you want to use moment later
              this.setState({ [key]: formattedDate });
            } else {
              this.setState({ [key]: null });
        }
      };
    setDriverId =(e) => {
        this.setState({ empId: e });
       }
    setTruckId = (e) => {
        this.setState({ truckId: e });
        }
    setText = e => {
        this.setState({ notes: e.target.value });
        }
    correctDefecte = (idTruck_PreInspection_Record, truckId) => {
            this.props.dispatch(updateIsDefectsCorrected(idTruck_PreInspection_Record, truckId, this.state.notes, false))
                .then(() => {
                    notify.createNotification('success', "Defects are Corrected successfully", this.props.refNotify);
                    this.getInspectionReport(this.state.empId, this.state.fromDate, this.state.truckId, this.state.isDefected);
                    this.setState({empId:'',fromDate:'',truckId:'',isDefected:true});
                });
        }
    beforeCorrectDefecte = (idTruck_PreInspection_Record, truckId) => {
            this.props.dispatch(updateIsDefectsCorrected(idTruck_PreInspection_Record, truckId, this.state.notes, true))
                .then(() => {
                    notify.createNotification('success', "Defects are Corrected successfully", this.props.refNotify);
                this.getInspectionReport(this.state.empId, this.state.fromDate, this.state.truckId, this.state.isDefected);
                this.setState({empId:'',fromDate:'',truckId:'',isDefected:true});
                });
        }
     buildDataFormatForExport = () => {
            return (
              [{
                columns: [{ title: 'Record ID' }, { title: 'Driver ID' },{ title: 'Inspection Type' },{ title: 'Inspection Date/Time' },{ title: 'Truck' },{ title: 'Defect' }],
                data: this.props.data.map(item => {
                  return [{ value: item.idTruck_PreInspection_Record || '' }, { value: item.driverId || '' }, { value: item.inspectionType || '' },{ value: item.inspectionDateTime || '' },{ value: item.truckId || '' },{ value: item.defectType || '' }]
                })
              }]
            )
          }

     render() {
      const getColumns = [
                {
                    accessor: 'idTruck_PreInspection_Record',
                    Header: 'Record ID',
                    style: { textAlign: 'center' }
                },
                {
                    accessor: 'driverId',
                    Header: 'Driver ID',
                    style: { textAlign: 'center' }
                },
                {
                    accessor: 'inspectionType',
                    Header: 'Inspection Type',
                    style: { textAlign: 'center' }
                },
                {
                    accessor: 'inspectionDateTime',
                    Header: 'Inspection Date/Time',
                    style: { textAlign: 'center' }
                },
                {
                    accessor: 'truckId',
                    Header: 'Truck',
                    style: { textAlign: 'center' }
                },
                {
                    accessor: 'defectType',
                    Header: 'Defect',
                    style: { textAlign: 'center' },
                },
                {
                    Header: 'Action',
                    style: { textAlign: 'center' },
                     Cell: ({row}) => (
                         <div>
                             {(!basicAccess.edit)||(row._original.isVehicleHaveDefects == 0 || row._original.defects_corrected == 1) ? null :
                             <button className='btn-primary btn-sm' 
                                onClick={() => {
                                  this.setState({ editNoteModalIsOpen: true, notes: "", 
                                    idTruck_PreInspection_Record: row._original.idTruck_PreInspection_Record, truckId: row._original.truckId 
                                   });
                             }}
                             ><i class="fa fa-check-square-o" aria-hidden="true"></i></button> }
                             <button className='btn-danger btn-sm' 
                             onClick={() => { 
                                this.getInspectionReportPdf(row._original.idTruck_PreInspection_Record) }}
                             > <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                             </button>
                         </div>
                     ),
                }
            ]
        

        return (
            <Fragment>
              <div className="page-header">
                    <div className="row mb-10">
                        <div className="col-md-12 col-sm-12">
                            <div className="title">
                                <h4> {`${pageTitle}`} </h4>
                            </div>
                        </div>
                    </div>
                </div>
                 <div className="pd-10 bg-white border-radius-4 box-shadow">
                  <div className="card form-group">
                   <div className="card-body pd-10">
                    <Form>
                     <div className="row align-items-center">
                     {/* Truck ID Field */}
                      <div className="col-md-3">
                       <label htmlFor="truckId">TRUCK ID</label>
                      <div>
                      <ReactSelect 
                            isClearable={true}
                            name="TruckId"
                            closeMenuOnSelect={true}
                            notAmultiSelect={true}
                            placeholder="Truck Id"
                            options={this.props.allInvoiceObj.truckList.map((item, t) => {
                                return ({ value: item.truckID, label: item.truckID })
                            })}
                            value={{
                                value: (this.state.truckId || '').toString(),
                                label: (this.state.truckId || '').toString()
                            }}
                            onChange={(selectedOption) => {
                                this.onSummaryByFieldChange('truckId', parseInt(selectedOption && selectedOption.value||''));
                            }}
                        />
                    </div>
                </div>

               {/* Driver ID Field */}
                <div className="col-md-3">
                 <label htmlFor="truckId">DRIVER ID</label>
                 <div>
                        <ReactSelect 
                            isClearable={true}
                            name="empId"
                            closeMenuOnSelect={true}
                            notAmultiSelect={true}
                            placeholder="Emp Id"
                            options={this.props.allInvoiceObj.driverList.map((item, t) => {
                                return ({ value: item.empId, label: item.empId.toString() })
                            })}
                            value={{
                                value: (this.state.empId || '').toString(),
                                label: (this.state.empId || '').toString()
                            }}
                            onChange={(selectedOption) => {
                                this.onSummaryByFieldChange('empId', parseInt(selectedOption && selectedOption.value||''));
                            }}
                        />
                    </div>
                 </div>

               {/* Date Field */}
              <div className="col-md-2">
               <label>DATE</label>
                <DatePicker
                    className="form-control"
                    selected={this.state.fromDate ? new Date(this.state.fromDate) : null}
                    onChange={(date) => this.handleDateChange(date, 'fromDate')}
                    placeholderText="MM/DD/YYYY"
                    showMonthDropdown={true}
                    showYearDropdown={true}
                    />
                </div>

               {/* Checkbox Field with extra spacing */}
                    <div className="col-md-3 d-flex align-items-center mt-2">
                        <input
                        className="form-check-input"
                        type="checkbox"
                        value="isDefected"
                        id="isDefected"
                        name="isDefected"
                        checked={this.state.isDefected}
                        onChange={(e) => { this.setState({ isDefected: !this.state.isDefected }) }}
                        />
                        <label className="form-check-label ml-2" htmlFor="isDefected">
                        Is-Defected
                        </label>
                    </div>
                    <div className="col-8 form-group mt-3">
                        <button type="button" className="btn btn-success custom-reports-btn mr-2"  onClick={() => 
                        {this.getInspectionReport(this.state.empId, this.state.fromDate, this.state.truckId, this.state.isDefected);this.setState({empId:'',fromDate:'',truckId:'',isDefected:true});}
                        } >Go</button>
                            <TmExportExcel
                            name={"InspectionReport"}
                            filename={`${pageTitle}`} 
                            fileExtension={'xlsx'}
                            element={<button className="btn btn-warning btn-sm"><i className="fa fa-file-excel-o"></i> Export</button>}
                            dataSet={this.buildDataFormatForExport()}
                            />
                        </div>
                    </div>
              </Form>
          </div>
          <div className="row">
            <div className="col-md-12 col-sm-12 mb-30">
            <TmReactTable
              filterable
              sortable
              resizable
              defaultPageSize={10}
              data={this.props.data}
              columns={getColumns}
            />
          </div>
        </div>
      </div>
      <Modal
        show={this.state.editNoteModalIsOpen} 
        contentLabel="Edit Note"
        >
            <div className="modal-body">
             <div className="row">   
              <div className="col-md-12 col-sm-12">
                 <h5>Are you sure want to clear the defects?</h5>
              </div>
             </div>
              <form className="text-center">
                <textarea className="col-md-12 txtcontrol" name="note" rows="3" value={this.state.notes} onChange={this.setText} 
                />
                <br /><br />
                <div className="row">
                <div className="modal-footer">
                <input type="button" className="btn btn-success" name="edit" style={{ width: '150px' }} value="Defect Repaired" onClick={() => {
                    this.correctDefecte(this.state.idTruck_PreInspection_Record,this.state.truckId, this.state.driverIdtobeFix)
                    this.setState({ editNoteModalIsOpen: false })
                }}
                />{'  '}
                <input type="button" className="btn btn-warning" name="edit" style={{ width: '180px' }} value="No Need To Correct" onClick={() => {
                     this.beforeCorrectDefecte(this.state.idTruck_PreInspection_Record, this.state.truckId, this.state.driverIdtobeFix)
                    this.setState({ editNoteModalIsOpen: false })
                }} />{'  '}
                <button onClick={() => { this.setState({ editNoteModalIsOpen: false }) }} className="btn btn-danger" style={{ width: '100px' }}>Cancel</button>
                </div>
                </div>
            </form>
            </div>
        </Modal>
     </div>
     </Fragment>
     )
   }
}
const mapStateToProps = (state, ownProps) => {
	return {
		refNotify: state.refNotify,
        childCompList: state.searchInvoiceList.childComList,
        locations: state.location.locationList,
        data:state.InspectionManageObj.inspectionReport,
        allInvoiceObj: state.allInvoice
	}
};
export default withRouter(connect(mapStateToProps)(DrvirInspection));